import { ComparisonType } from './comparison-type';

export class NumericComparison {
    constructor(
        public comparisonType: ComparisonType,
        public value: number
    ) {}
}
